import { DEFAULT_PAGINATION } from 'constants/app.constants';

export const calculatePageNumber = (rowCount, elementCountInReduxStore, totalElementsInDb) => {
  if (elementCountInReduxStore < totalElementsInDb) {
    return Math.ceil(rowCount / DEFAULT_PAGINATION.PAGE_SIZE) + 1;
  }
  return null;
};
